<template>
<div class="box">
  <div class="cirLine"></div>
  <div class="firTitle">
    <span class="cirCon">{{ num }}</span>{{ title }}
  </div>
  <div class="box-content">
    <slot></slot>
  </div>
</div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    num: {
      type: Number,
      default: 0
    }
  },
};
</script>

<style scoped lang="less">
.box{
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.cirLine {
  width: 100%;
  border-top: 1px dashed #ccc;
}

.box-content{
  flex: 1;
  width: 90%;
  min-width: 0;
}

.firTitle {
  margin-top: 40px;
  text-align: center;
  font-size: 22px;
  color: rgba(75, 141, 243, 1);
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;

  .cirCon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 26px;
    height: 26px;
    border-radius: 12px;
    background: #4B8DF3;
    color: #fff;
  }
}
</style>
